$(function () {
  $("#submit-memo").on("click", function () {
    var cartData;

    $.ajax({
      async: false,
      type: "GET",
      global: false,
      dataType: "json",
      url: "/cart.js",
      success: function (data) {
        cartData = data;

        $("#validate-error").css("display", "none");
        var validateStatus = true;

        // console.log(cartData);
        //console.log('First Name: ' + $('#first_name').val());

        //alert('hi!');
        var public_token = "4NxhvvJ7up6WTMtX7ZcBss4dAkbNbKefQVXtsXvr";

        var shipping_zip = $("#shipping_zip").val();
        if (shipping_zip == "") {
          validateStatus = false;
          $("#validate-error").css("display", "block");
          $("#validate-error-message").text(
            "Shipping State is a required field. Please be sure to fill it out."
          );
        }

        var shipping_state = $("#shipping_state").val();
        if (shipping_state == "") {
          validateStatus = false;
          $("#validate-error").css("display", "block");
          $("#validate-error-message").text(
            "Shipping State is a required field. Please be sure to fill it out."
          );
        }

        var shipping_city = $("#shipping_city").val();
        if (shipping_city == "") {
          validateStatus = false;
          $("#validate-error").css("display", "block");
          $("#validate-error-message").text(
            "Shipping City is a required field. Please be sure to fill it out."
          );
        }

        var shipping_address = $("#shipping_address").val();
        if (shipping_address == "") {
          validateStatus = false;
          $("#validate-error").css("display", "block");
          $("#validate-error-message").text(
            "Shipping Address is a required field. Please be sure to fill it out."
          );
        }

        var store_phone = $("#store_phone").val();
        if (store_phone == "") {
          validateStatus = false;
          $("#validate-error").css("display", "block");
          $("#validate-error-message").text(
            "Store Phone is a required field. Please be sure to fill it out."
          );
        }
        var cell_phone = $("#cell_phone").val();

        var store_name = $("#store_name").val();
        if (store_name == "") {
          validateStatus = false;
          $("#validate-error").css("display", "block");
          $("#validate-error-message").text(
            "Store Name is a required field. Please be sure to fill it out."
          );
        }

        var email_address = $("#email_address").val();
        var regEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/g;
        if (email_address == "") {
          validateStatus = false;
          $("#validate-error").css("display", "block");
          $("#validate-error-message").text(
            "Email address is a required field. Please be sure to fill it out."
          );
        } else if (!regEmail.test(email_address)) {
          validateStatus = false;
          $("#validate-error").css("display", "block");
          $("#validate-error-message").text(
            "Please enter a valid email address."
          );
        } else {
          $("#validate-error").css("display", "block");
          $("#validate-error-message").text();
        }

        var last_name = $("#last_name").val();
        if (last_name == "") {
          validateStatus = false;
          $("#validate-error").css("display", "block");
          $("#validate-error-message").text(
            "Last Name is a required field. Please be sure to fill it out."
          );
        }

        var first_name = $("#first_name").val();
        if (first_name == "") {
          validateStatus = false;
          $("#validate-error").css("display", "block");
          $("#validate-error-message").text(
            "First Name is a required field. Please be sure to fill it out."
          );
        }

        // if ($("#existing_customer").is(":checked")) {
        //   var existing_customer = 1;
        // } else {
        //   var existing_customer = 0;
        // }

        // if ($("#new_customer").is(":checked")) {
        //   var new_customer = 1;
        // } else {
        //   var new_customer = 0;
        // }

        // if (existing_customer == 0 && new_customer == 0) {
        //   validateStatus = false;
        //   $("#validate-error").css("display", "block");
        //   $("#validate-error-message").text(
        //     "You must choose if you are a new or existing customer at the top of the form."
        //   );
        // }
        var existing_customer = 1;
        var new_customer = 1;
        var notes = $("#notes").val();
        var start_event_date = $("#start_event_date").val();
        var end_event_date = $("#end_event_date").val();
        var requestPurpose = '';
        if($("#customer_presentation").is(':checked')) {
        	requestPurpose += '7 Day Memo For Customer Presentation';
        }
if ($("#trunk_show").is(':checked')) {
    $("#sell_agreement").css('display', 'block');

    if (requestPurpose.length) { 
        requestPurpose += ', '; 
    }
    requestPurpose += 'Trunk Show/Special Event';          
} else {
    $("#sell_agreement").css('display', 'none');      
}
        if($("#stock_purchase").is(':checked')) {
        	if(requestPurpose.length) { requestPurpose += ', '; }
        	requestPurpose += 'Selecting Memo Items For Inventory stock purchase';
        }
        if($("#purchase_terms_30_days").is(':checked')) {
        	if(requestPurpose.length) { requestPurpose += ', '; }
        	requestPurpose += 'Purchase Terms 30 Days';
        }
        if($("#other").is(':checked')) {
        	if(requestPurpose.length) { requestPurpose += ', '; }
        	requestPurpose += 'Other';
        }
        
        var cart_data = cartData;

        if (validateStatus == true) {
          var orderData = new Object();
          var products = new Object();
          orderData.items_subtotal_price = cartData.items_subtotal_price;
          orderData.item_count = cartData.item_count;
          orderData.total_price = cartData.total_price;
          orderData.total_price = cartData.total_price;
          orderData.items = [];

          //myObject.age = 12;
          //myObject.pets = ["cat", "dog"];

          //console.log("SUBTOTAL: " + cartData.items_subtotal_price);
          //console.log("item_count: " + cartData.item_count);
          var count = 0;

          //console.log('items: ' + cartData.items);

          $.each(cartData.items, function (index, item) {
            // console.log('Product: ' + item.title);
            var product = new Object();
            product.id = item.id;
            product.title = item.title;
            product.quantity = item.quantity;
            product.price = item.price;
            product.sku = item.sku;
            product.url = item.url;
            product.image = item.image;
            product.handle = item.handle;

            orderData.items.push(product);

            count = count + product.quantity;

            //console.log('Count: ' + count);

            if (count == orderData.item_count) {
              $("#submit-memo").text("Processing...");
              var memoData = {
                public_token: public_token,
                existing_customer: existing_customer,
                is_inside_sales: 0,
                first_name: first_name,
                last_name: last_name,
                store_name: store_name,
                email_address: email_address,
                store_phone: store_phone,
                cell_phone: cell_phone,
                shipping_address: shipping_address,
                shipping_city: shipping_city,
                shipping_state: shipping_state,
                shipping_zip: shipping_zip,
                notes: notes,
                requestPurpose: requestPurpose,
                start_event_date: start_event_date,
                end_event_date: end_event_date,
                orderData: orderData,
              };

              $.post(
                "https://shopify.braintreeeasysoft.com/mdj/shop-api/memo",
                JSON.stringify(memoData)
              ).done(function (data) {
                $("#memo-cart").css("display", "none");
                $("#memo-success").css("display", "block");

                $.ajax({
                  async: false,
                  type: "POST",
                  global: false,
                  dataType: "json",
                  url: "/cart/clear.js",
                  success: function (data) {
                    //console.log("Cleared? " + data);
                  },
                });
              });
            }
          });
        }
      },
    });
  });

  $("#submit-inside-memo").on("click", function () {
    var cartData;

    $.ajax({
      async: false,
      type: "GET",
      global: false,
      dataType: "json",
      url: "/cart.js",
      success: function (data) {
        cartData = data;

        $("#validate-error").css("display", "none");
        var validateStatus = true;

        var public_token = "4NxhvvJ7up6WTMtX7ZcBss4dAkbNbKefQVXtsXvr";

        var email_address = $("#email_address").val();
        if (email_address == "") {
          validateStatus = false;
          $("#validate-error").css("display", "block");
          $("#validate-error-message").text(
            "Sales Rep Email address is a required field. Please be sure to fill it out."
          );
        }

        var client_id = $("#client_id").val();
        if (client_id == "") {
          validateStatus = false;
          $("#validate-error").css("display", "block");
          $("#validate-error-message").text(
            "Client ID is a required field. Please be sure to fill it out."
          );
        }

        var notes = $("#notes").val();
        var store_phone = $("#store_phone").val();
         var start_event_date = $("#start_event_date").val();
        var end_event_date = $("#end_event_date").val();
        
        var requestPurpose = '';
        if($("#short_term_memo_for_customer_presentation").is(':checked')) {
        	requestPurpose += '7 Day Memo For Customer Presentation';
        }
        if($("#trunk_show_special_event_dates").is(':checked')) {
    $("#sell_agreement").css('display', 'block');

    if (requestPurpose.length) { 
        requestPurpose += ', '; 
    }
    requestPurpose += 'Trunk Show/Special Event';          
} else {
    $("#sell_agreement").css('display', 'none');      
}
       
        if($("#selecting_memo_items_for_inventory_stock_purchase").is(':checked')) {
        	if(requestPurpose.length) { requestPurpose += ', '; }
        	requestPurpose += 'Selecting Memo Items For Inventory stock purchase';
        }
        if($("#purchase_terms_30_days").is(':checked')) {
        	if(requestPurpose.length) { requestPurpose += ', '; }
        	requestPurpose += 'Purchase Terms 30 Days';
        }
        if($("#other").is(':checked')) {
        	if(requestPurpose.length) { requestPurpose += ', '; }
        	requestPurpose += 'Other';
        }
        
        var cart_data = cartData;

        if (validateStatus == true) {
          var orderData = new Object();
          var products = new Object();
          orderData.items_subtotal_price = cartData.items_subtotal_price;
          orderData.item_count = cartData.item_count;
          orderData.total_price = cartData.total_price;
          orderData.total_price = cartData.total_price;
          orderData.items = [];

          //myObject.age = 12;
          //myObject.pets = ["cat", "dog"];

          //console.log("SUBTOTAL: " + cartData.items_subtotal_price);
          //console.log("item_count: " + cartData.item_count);
          var count = 0;

          //console.log('items: ' + cartData.items);

          $.each(cartData.items, function (index, item) {
            //console.log('Product: ' + item.title);
            var product = new Object();
            product.id = item.id;
            product.title = item.title;
            product.quantity = item.quantity;
            product.price = item.price;
            product.sku = item.sku;
            product.url = item.url;
            product.image = item.image;
            product.handle = item.handle;

            orderData.items.push(product);

            count = count + product.quantity;

            //console.log('Count: ' + count);

            if (count == orderData.item_count) {
              $("#submit-memo").text("Processing...");
              var memoData = {
                public_token: public_token,
                is_inside_sales: 1,
                client_id: client_id,
                store_phone: store_phone,
                email_address: email_address,
                notes: notes,
                requestPurpose: requestPurpose,
                start_event_date: start_event_date,
                end_event_date: end_event_date,
                orderData: orderData,
              };
              
              $.post(
                "https://shopify.braintreeeasysoft.com/mdj/shop-api/memo",
                JSON.stringify(memoData)
              ).done(function (data) {
                  $("#memo-cart").css("display", "none");
                  $("#memo-success").css("display", "block");

                  $.ajax({
                    async: false,
                    type: "POST",
                    global: false,
                    dataType: "json",
                    url: "/cart/clear.js",
                    success: function (data) {
                      // console.log("Cleared? " + data);
                    },
                  });
                });
            }
          });
        }
      },
    });
  });
});
